<!-- Global Hero Section -->
<header class="hero-section-global">
  <div class="hero-background-global"
    style="background-image: url('//images.ctfassets.net/f6ou4743hwzs/2xaL3IYyS5iU8bcXoWAOdX/9d1784950839614bbbcaa593c23ee090/whyblm.jpg'); background-position: center bottom;">
  </div>
  <div class="hero-overlay-global"></div>
  <div class="hero-content-global">
    <h1 class="hero-title-global">Get in Touch</h1>
    <p class="lead"
      style="color: rgba(255,255,255,0.9); border: none; background: none; text-shadow: 0 2px 4px rgba(0,0,0,0.5);">
      We’d love to hear from you. Plan your visit or reach out with any questions.
    </p>
  </div>
</header>

<main class="container contact-container">

  <div class="contact-grid">
    <!-- Address Card -->
    <a href="https://goo.gl/maps/ScmJEb1U5wZ97o9DA" target="_blank" class="contact-card">
      <div class="card-icon">
        <mat-icon>place</mat-icon>
      </div>
      <h3>Visit Us</h3>
      <p>
        Bayou Lacombe Museum<br>
        61115 S St. Mary Street<br>
        Lacombe, LA 70445
      </p>
      <span class="action-link">Get Directions &rarr;</span>
    </a>

    <!-- Email Card -->
    <a href="mailto:info&#64;bayoulacombemuseum.com" class="contact-card">
      <div class="card-icon">
        <mat-icon>email</mat-icon>
      </div>
      <h3>Email Us</h3>
      <p>
        info&#64;bayoulacombemuseum.com
      </p>
      <span class="action-link">Send a Message &rarr;</span>
    </a>

    <!-- Hours Card -->
    <div class="contact-card static-card">
      <div class="card-icon">
        <mat-icon>schedule</mat-icon>
      </div>
      <h3>Opening Hours</h3>
      <p>
        Saturday: Noon - 4:00 PM<br>
        <small style="opacity: 0.8; display: block; margin-top: 5px;">*Private tours available by appointment</small>
      </p>
    </div>
  </div>

<!-- Message & Visit Information Section -->
  <section class="contact-main-grid">
    <!-- Left Column: Form Card -->
    <div class="contact-form-card">
      <div [hidden]="success">
        <div class="form-title-group">
          <h2>Send Us a Message</h2>
          <p>Have an inquiry about upcoming exhibits, school field trips, donations, or local genealogy research? Our staff is here to help.</p>
        </div>

        <form [formGroup]="contactForm" (ngSubmit)="onSubmit()" class="styled-contact-form">
          <div class="form-row-2">
            <mat-form-field appearance="outline" class="full-width">
              <mat-label>Your Name</mat-label>
              <input matInput formControlName="name" placeholder="Full name" autocomplete="name" required>
              <mat-icon matPrefix>person</mat-icon>
              <mat-error *ngIf="name.errors && (name.dirty || name.touched)">Name is required</mat-error>
            </mat-form-field>

            <mat-form-field appearance="outline" class="full-width">
              <mat-label>Email Address</mat-label>
              <input matInput formControlName="email" placeholder="you@example.com" autocomplete="email" required>
              <mat-icon matPrefix>email</mat-icon>
              <mat-error *ngIf="email.errors && (email.dirty || email.touched)">Valid email is required</mat-error>
            </mat-form-field>
          </div>

          <mat-form-field appearance="outline" class="full-width">
            <mat-label>Inquiry Topic / Subject</mat-label>
            <input matInput formControlName="subject" placeholder="e.g., School Field Trip, Artifact Donation, General Question" required>
            <mat-icon matPrefix>help_outline</mat-icon>
            <mat-error *ngIf="subject.errors && (subject.dirty || subject.touched)">Subject is required</mat-error>
          </mat-form-field>

          <mat-form-field appearance="outline" class="full-width">
            <mat-label>Your Message</mat-label>
            <textarea matInput formControlName="message" rows="5" placeholder="Please describe how we can assist you..." required></textarea>
            <mat-error *ngIf="message.errors && (message.dirty || message.touched)">Please enter at least 10 characters</mat-error>
          </mat-form-field>

          <div class="form-actions">
            <button mat-flat-button color="primary" class="contact-submit-btn" [disabled]="contactForm.invalid || loading" type="submit">
              <mat-icon>send</mat-icon>
              <span>{{ loading ? 'Sending to Staff...' : 'Send Message' }}</span>
            </button>
            <span class="direct-email-hint">
              Or email directly: <a href="mailto:info@bayoulacombemuseum.com">info&#64;bayoulacombemuseum.com</a>
            </span>
          </div>
        </form>
      </div>

      <!-- Success State -->
      <div class="success-message" *ngIf="success">
        <mat-icon class="success-icon">check_circle</mat-icon>
        <h3>Thank You, {{ submittedData.name }}!</h3>
        <p>Your message regarding "<strong>{{ submittedData.subject }}</strong>" has been dispatched directly to the museum board and staff.</p>

        <!-- Direct Email Fallback Option -->
        <div class="email-action-box">
          <p class="email-action-desc">
            Need to attach documents or photos? Open your personal email client with this inquiry pre-filled:
          </p>
          <a [href]="mailtoLink" class="email-confirm-btn">
            <mat-icon>email</mat-icon>
            <span>Open in Email Client</span>
          </a>
        </div>
      </div>
    </div>

    <!-- Right Column: Quick Info & Planning Sidebar -->
    <aside class="contact-sidebar">
      <div class="sidebar-card">
        <h3>Plan Your Visit</h3>
        <div class="sidebar-item">
          <mat-icon class="sidebar-icon">schedule</mat-icon>
          <div>
            <strong>General Admission</strong>
            <p>Saturdays: Noon – 4:00 PM</p>
          </div>
        </div>
        <div class="sidebar-item">
          <mat-icon class="sidebar-icon">groups</mat-icon>
          <div>
            <strong>Private & School Tours</strong>
            <p>Thursday – Saturday by appointment</p>
          </div>
        </div>
        <div class="sidebar-item">
          <mat-icon class="sidebar-icon">confirmation_number</mat-icon>
          <div>
            <strong>Admission Pricing</strong>
            <p>$3 Adults &bull; $2 Seniors & Students &bull; Under 6 Free</p>
          </div>
        </div>
        <div class="sidebar-cta-wrap">
          <a routerLink="/appointment" class="sidebar-cta-btn">
            <mat-icon>calendar_today</mat-icon>
            <span>Book a Group Tour</span>
          </a>
        </div>
      </div>

      <div class="sidebar-card phone-card">
        <h3>Direct Phone Support</h3>
        <p>Give us a call during museum open hours or leave a voicemail anytime:</p>
        <a href="tel:(985)664-0256" class="phone-link">
          <mat-icon>phone</mat-icon>
          <span>(985) 664-0256</span>
        </a>
      </div>
    </aside>
  </section>

  <!-- Interactive Map Section -->
  <section class="map-section">
    <div class="map-header">
      <h2>Museum Location & Driving Directions</h2>
      <p>Located in the heart of historic Lacombe on South St. Mary Street, just south of Highway 190.</p>
    </div>
    <div class="map-frame-wrapper">
      <iframe
        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3449.889370836956!2d-89.94098768488214!3d30.29746698179045!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x889d88f6b0b0b0b1%3A0x6b0b0b0b0b0b0b0b!2s61115%20S%20St%20Mary%20St%2C%20Lacombe%2C%20LA%2070445!5e0!3m2!1sen!2sus!4v1620000000000!5m2!1sen!2sus"
        title="Bayou Lacombe Museum Location Map"
        width="100%" height="420" style="border:0;" allowfullscreen="" loading="lazy"></iframe>
    </div>
  </section>

</main>